import { z } from "zod";

export const snmpVersionEnum = ["1", "2c", "3"] as const;
export type SNMPVersion = (typeof snmpVersionEnum)[number];

export const estatusRouterEnum = ["online", "offline", "unknown", "error"] as const;
export type EstatusRouter = (typeof estatusRouterEnum)[number];

const ipRegex = /^\d{1,3}(\.\d{1,3}){3}$/;

export const routerCreateSchema = z.object({
  nombre: z.string().min(1).max(100),
  descripcion: z.string().optional().or(z.literal("")),
  ip_address: z.string().regex(ipRegex, "IP inválida"),
  via_vpn: z.boolean().default(false),
  api_user: z.string().min(1).max(50),
  api_pass: z.string().min(1),
  api_port: z.coerce.number().int().min(1).max(65535).default(8728),
  api_ssl: z.boolean().default(false),
  snmp_community: z.string().max(50).optional().or(z.literal("")),
  snmp_port: z.union([z.coerce.number().int().min(1).max(65535), z.literal("")]).optional(),
  snmp_version: z.enum(snmpVersionEnum).optional(),
  wan_interface: z.string().max(50).optional().or(z.literal("")),
  ubicacion: z.string().max(200).optional().or(z.literal("")),
  tags: z.array(z.string()).default([]),
});

// En update, api_pass es opcional (si no lo mandas, no cambia)
export const routerUpdateSchema = routerCreateSchema
  .partial()
  .extend({ activo: z.boolean().optional() });

export type RouterCreateInput = z.infer<typeof routerCreateSchema>;
export type RouterUpdateInput = z.infer<typeof routerUpdateSchema>;

export type RouterSummary = {
  id: string;
  nombre: string;
  ip_address: string;
  via_vpn: boolean;
  estatus: EstatusRouter;
  modelo: string | null;
  version_ros: string | null;
  identity: string | null;
  activo: boolean;
  last_seen: string | null;
  created_at: string;
};

export type RouterDetail = RouterSummary & {
  descripcion: string | null;
  api_user: string;
  api_port: number;
  api_ssl: boolean;
  snmp_community: string | null;
  snmp_port: number | null;
  snmp_version: SNMPVersion | null;
  wan_interface: string | null;
  ubicacion: string | null;
  tags: string[];
  updated_at: string;
};

export type PagedRouters = {
  items: RouterSummary[];
  total: number;
  page: number;
  size: number;
  pages: number;
};

export type TestConnectionResponse = {
  success: boolean;
  latency_ms: number | null;
  identity: string | null;
  board_name: string | null;
  version: string | null;
  error: string | null;
};

// F24.3: OVPN movido a feature /vpn — ver web/src/features/vpn/schemas.ts
